
  import ScreenSize from '@/mixins/ScreenSize';
  import clearableTabIndex from '@/mixins/clearableTabIndex';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';

  export default {
    name: 'ResetPasswordForm',
    components: {
      DialogsBaseSection,
    },
    mixins: [clearableTabIndex, ScreenSize],
    data() {
      return {
        password: '',
        confirmPassword: '',
        section: {},
        passwordRules: [
          (v) => !!v || this.$t('password.required'),
          (v) => (v && v.length >= 8) || this.$t('password.required_size'),
          (v) =>
            /(?=.*[A-Z])/.test(v) || this.$t('password.required_uppercase'),
          (v) =>
            /(?=.*[a-z])/.test(v) || this.$t('password.required_lowercase'),
          (v) => /(?=.*\d)/.test(v) || this.$t('password.required_number'),
          (v) =>
            /([&?!@$%#_/=*<>-])/.test(v) ||
            /([(){}~,.;:+])/.test(v) ||
            /([[])/.test(v) ||
            /(])/.test(v) ||
            this.$t('password.required_special_character'),
        ],
        showPassword: false,
        showConfirmPassword: false,
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('reset-password-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    computed: {
      passwordMatchRule() {
        return (v) => v === this.password || 'Passwort muss gleich sein';
      },
    },
    methods: {
      setUpNewPassword() {
        if (
          this.password &&
          this.confirmPassword &&
          this.password === this.confirmPassword
        ) {
          this.$store
            .dispatch('api/candidateAccount/patchResetPassword', {
              id: this.$route.query.candidateAccountId,
              data: {
                token: this.$route.query.resetPasswordToken,
                password: this.confirmPassword,
              },
            })
            .then((response) => {
              if (response.status === 204) {
                this.$emit('close-dialog');
                this.$notifications.showNotification({
                  message: this.$t('forgot.password.success'),
                  color: 'success',
                  timeout: 5000,
                });
                this.removeUrlParam();
              }
            })
            .catch((e) => {
              if (e.response.status !== 400) {
                throw e;
              }
              this.$emit('change-dialog-page', 'forgotPassword');
              this.$notifications.showNotification({
                message: this.$t('forgot.password.error'),
                color: 'error',
                timeout: 5000,
              });
            });
        }
      },
      removeUrlParam() {
        const {path, params} = this.$route;
        const query = {};
        const newUrl = this.$router.resolve({path, query, params});
        this.$router.push(newUrl.href);
      },
    },
  };
